var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAudioOn(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, ["title", "titleId"]);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 69 45",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-15.18,-27.5)",
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: "5px"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "30.82 40.73 50.17 30.44 50.17 69.56 30.82 59.27"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m26.24 40.73h4.58v18.55h-4.58c-4.47 0-8.11-3.63-8.11-8.11v-2.33c0-4.47 3.63-8.11 8.11-8.11z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m73.17 67.37c4.93-4.27 8.06-10.57 8.06-17.58s-2.92-12.9-7.58-17.16"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m68.02 37.91c3.37 2.86 5.52 7.12 5.52 11.88 0 5.03-2.41 9.5-6.12 12.35"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m67.42 62.13c3.71-2.85 6.12-7.32 6.12-12.35 0-4.76-2.15-9.02-5.52-11.88"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m62.34 43.23c2.12 1.41 3.51 3.82 3.51 6.56 0 3.06-1.74 5.7-4.29 7.01"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m61.57 56.8c2.54-1.31 4.29-3.95 4.29-7.01 0-2.74-1.4-5.14-3.51-6.56"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAudioOn);
export default __webpack_public_path__ + "static/media/audio-on.07f05068.svg";
export { ForwardRef as ReactComponent };